import React from 'react';
import { Shield } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-b from-saffron-50 via-white to-white border-b border-slate-100 py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-lg bg-saffron-100 flex items-center justify-center">
              <Shield className="w-6 h-6 text-saffron-600" />
            </div>
            <h1 className="font-display text-4xl md:text-5xl font-bold text-bharat-navy">Privacy Policy</h1>
          </div>
          <p className="text-lg text-slate-600 mt-4">
            Your privacy is important to us. Learn how bharat-calculator.com handles your data.
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="prose prose-sm max-w-none text-slate-700 space-y-8">

          <section>
            <h2 className="font-display text-2xl font-bold text-bharat-navy mb-4">1. Introduction</h2>
            <p>
              bharat-calculator.com ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we handle your information when you use our website.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-bharat-navy mb-4">2. What Information Do We Collect?</h2>
            <p>
              We do <span className="font-bold">not</span> collect or store any personal information. We do not use cookies, analytics, or trackers.
            </p>
            <p>
              If you contact us by email, we will receive your email address and any information you include in your message. We use this only to respond to your inquiry.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-bharat-navy mb-4">3. How Do We Use Your Information?</h2>
            <p>
              We use your email only to reply to your inquiry. We do not share, sell, or use your information for any other purpose.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-bharat-navy mb-4">4. Data Security</h2>
            <p>
              We do not store any user data. Emails you send are handled by your email provider and our inbox provider.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-bharat-navy mb-4">5. Third-Party Services</h2>
            <p>
              Our website does not use third-party analytics, advertising, or tracking services.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-bharat-navy mb-4">6. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <p className="mt-3 text-indgreen-600 font-semibold">
              Email: info@bharat-calculator.com
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-bharat-navy mb-4">7. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Changes will be posted on this page.
            </p>
            <p className="text-sm text-slate-500 mt-4">
              Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;

